//Вынес сюда, чтобы не дублировать код для PDF
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';

export function selectCaseById(id:string){
    const storeProjectStructure = useStoreProjectStructure();
    const storeCaseConfiguration = useStoreCaseConfiguration();

    const caseConfiguration = storeProjectStructure.getCaseDataById(id);
    storeProjectStructure.setSelectedCaseId(id);

    // console.log('!!!!!!', caseConfiguration);

    if (caseConfiguration) {
        storeCaseConfiguration.$patch(JSON.parse(JSON.stringify(caseConfiguration)));
    } else {
        console.warn('Конфигурация не найдена!');
    }
}
